import PropTypes from "prop-types";
import React, { Component } from "react";
import { Button, ButtonToolbar, Container, FormGroup, FormLabel } from "react-bootstrap";
import Col from "react-bootstrap/Col";
import FormControl from "react-bootstrap/FormControl";
import Row from "react-bootstrap/Row";
import { FormattedMessage, injectIntl } from "react-intl";
import RichTextEditor from "../../common/richTextEditor/RichTextEditor";

class TemplateHeaderEdit extends Component {
  render() {
    const { surveyNameDraft, surveyDescriptionDraft } = this.props;
    return (
      <Container fluid>
        <Row className="py-3">
          <Col className="bg-light py-3">
            <FormGroup  className="mb-3">
              <FormLabel>
                <FormattedMessage id="survey.editor.title.survey.edit" />
              </FormLabel>
              <FormControl
                value={surveyNameDraft}
                onChange={this.onPropertyChange.bind(this, "surveyNameDraft")}
                autoComplete="off"
              />
            </FormGroup>
            <FormGroup  className="mb-3">
              <FormLabel>
                <FormattedMessage id="survey.editor.description" />
              </FormLabel>
              <RichTextEditor
                onTextChange={this.onDescriptonChange.bind(this, "surveyDescriptionDraft")}
                htmlContent={surveyDescriptionDraft ? surveyDescriptionDraft : "<p></p>"}
              />
            </FormGroup>
            <ButtonToolbar className="gap-sm">
              <Button variant="secondary" onClick={this.onSurveyChangedCanceled.bind(this)}>
                <FormattedMessage id="app.common.Cancel" />
              </Button>
              <Button onClick={this.onSurveyChanged.bind(this)}>
                <FormattedMessage id="survey.editor.save" />
              </Button>
            </ButtonToolbar>
          </Col>
        </Row>
      </Container>
    );
  }

  onPropertyChange(propName, event) {
    //only for title value
    this.props.propertyChange(propName, event.target.value);
  }

  onDescriptonChange(propName, event) {
    //only for description value
    this.props.propertyChange(propName, event);
  }

  onSurveyChanged() {
    //saves new values
    this.props.onConfirm(this.props.surveyTitleDraft, this.props.surveyDescriptionDraft);
  }

  onSurveyChangedCanceled() {
    //cancel changes
    this.props.changeEditState(false);
  }
}

TemplateHeaderEdit.propTypes = {
  propertyChange: PropTypes.func,
  onConfirm: PropTypes.func,
  onClose: PropTypes.func,
  changeEditState: PropTypes.func,
  surveyNameDraft: PropTypes.string,
  surveyDescriptionDraft: PropTypes.string,
  surveyTitleDraft: PropTypes.func
};
export default injectIntl(TemplateHeaderEdit);
